import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingStep from '../components/OnboardingStep';
import { toast } from 'sonner';

const DateOfBirthNew = () => {
  const navigate = useNavigate();
  const [date, setDate] = useState('');
  
  const handleContinue = () => {
    if (!date) {
      toast.error('Please select your date of birth');
      return;
    }
    
    const birthData = JSON.parse(localStorage.getItem('birthData') || '{}');
    birthData.date = date;
    localStorage.setItem('birthData', JSON.stringify(birthData));
    
    navigate('/time-of-birth');
  };
  
  return (
    <OnboardingStep
      step={2}
      totalSteps={5}
      title="When were you born?"
      reassurance="We need this for accurate calculations"
      trustNote="We use Swiss Ephemeris and Vedic calculations trusted by professional astrologers."
      onContinue={handleContinue}
      continueDisabled={!date}
    >
      <div className="space-y-4">
        <label className="block">
          <span className="text-sm font-medium text-stone-700 mb-2 block">
            Date of Birth
          </span>
          <input
            type="date"
            className="w-full px-4 py-4 rounded-input bg-stone-50 border-2 border-transparent focus:border-cosmic-500 focus:bg-white transition-all text-lg outline-none"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            max={new Date().toISOString().split('T')[0]}
          />
        </label>
      </div>
    </OnboardingStep>
  );
};

export default DateOfBirthNew;